import type { SVGProps } from 'react';

export function CompassIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 10.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3" />
      <path d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m5.657 5.343a1 1 0 0 0-.887-.277l-.136.036-6.477 2.158a3 3 0 0 0-1.897 1.897l-2.158 6.477a1 1 0 0 0 1.264 1.264l6.477-2.158a3 3 0 0 0 1.897-1.897l2.158-6.477a1 1 0 0 0-.24-1.023" />
    </svg>
  );
}
